import { makeStyles } from '@material-ui/core';

export default  makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #7D1FF5 0%, #DA48C5 99.98%)',
  },
  formWrap: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      paddingBottom: 32
    },
     padding: '27px 37px 0 27px',
  },
  formTitle: {
    fontWeight: theme.typography.fontWeightBold,
    [theme.breakpoints.down('xs')]: {
      fontSize: 20
    },
  },
  formControlRoot: {
    marginRight: 0,
  },
  formControlLabel: {
    fontSize: 14,
  },
  formReffWrap: {
    borderRight: '1px solid rgba(0, 0, 0, 0.11)',
    fontFamily: 'Inter',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 21,
      marginLeft: 32,
      marginRight: 32,
      paddingLeft: 0,
      paddingRight: 0,
      borderRight: 0,
      borderBottom: '1px solid rgba(0, 0, 0, 0.11)',
    }
  },
  formReffUserImg: {
    borderRadius: '50%',
    width: 48,
    height: 48,
    overflow: 'hidden',
    marginRight: 9,
    flexShrink: 0,
  },
  formReffUserText: {
    width: 'calc(100% - 53px - 10px)',
    letterSpacing: '-0.01em'
  },
  formReffUserName: {
    fontWeight: 700,
    lineHeight: '19px',
    fontSize: 16,
    marginBottom: 4
  },
  formReffUserSpecialist: {
    fontSize: 10,
    '-webkit-font-smoothing': 'antialiased'
  },
  formReffText: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 17,
    lineHeight: '26px'
  },
  formReffText2: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px'
  },
  reffBanner: {
    height: 159,
    width: 'auto',
    marginBottom: -40,
    marginTop: "auto",
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  reffBannerMobile: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      margin: 'auto',
    }
  },
  formReffImg: {
    width: 68,
    height: 68,
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  formWr: {
    width: 258,
    maxWidth: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },

  infoTitle:{
    fontWeight: 700,
    marginBottom : 18,
    [theme.breakpoints.down('xs')]: {
      fontSize: 22
    }
  },
  infoText:{
    color: '#000',
      fontSize: 14,
      marginBottom: 30
  },
    infoPerevaguTitle:{
        fontWeight: 700,
        marginBottom: 18,
      [theme.breakpoints.down('xs')]: {
       display: 'none'
      }
    },
    infoPerWr:{
        display: 'grid',
        gridGap: '30px 32px',
        gridTemplateColumns: '42% auto',
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: 'auto',
        gridGap: 18,
        display: 'none'
      }
    },
    infoPer:{
        display: 'grid',
        gridTemplateColumns: '27px auto',
        gridGap: 7
    },
    infoPerImgWr:{
        width: 27,
        height: 27,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    infoPerText:{
        fontSize: 12,
        fontWeight: 500
    },
    formLoginBtn:{
        fontWeight: 500,
        fontSize: 16,
        color: '#979FA9',
        '&:hover':{
            color: '#000'
        }
    },
    infoImg:{
        display: 'block',
        alignSelf: 'flex-end',
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      }
    },
    formCont:{
        display: 'grid',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
        paddingLeft:0
      }
    },
    regCallBack:{
        fontWeight: 700,
        fontSize: 14,
        color: '#fff',
        textDecoration: 'none'
    },
  formLogoWr:{
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
      marginBottom: 22
    }
  },
  formParent:{
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 56px)',
      margin: '0 auto 27px'
    }
  },
  infoImgMob:{
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      margin: 'auto',
      marginTop: 40
    }
  },
  infoPerevaguTitleMob:{
    fontSize: 13,
    border: '1px solid #000',
    borderRadius: 4,
    display: 'none',
    alignItems: 'center',
    padding: '11px 0',
    justifyContent: 'center',
    fontWeight: 700,
    marginTop: 32,
    [theme.breakpoints.down('xs')]: {
      display: 'flex'
    }
  },
  infoPerevaguTitleMobHide:{
    display: 'none'
  },
  infoPerevaguPlus:{
    marginRight: 7
  },
  infoPerWrShow:{
    display: 'grid'
  }

}));